import React from "react";
import apiFetch from "../helpers/requests";
import { useTranslation } from "react-i18next";

const ConfirmDeleteTrainingPlanModal = ({
  setShowConfirmDeleteModal,
  planId,
  handleDelete,
}) => {
  const { t } = useTranslation();

  const deleteTrainingPlan = async (planId: string) => {
    try {
      await apiFetch(`/deleteTrainingPlan`, {
        method: "POST",
        body: JSON.stringify({ planId }),
      });
    } catch (error) {
      console.error("Error deleting training plan:", error);
      throw error; // Let the caller handle UI feedback if needed, but here we just log
    }
  };

  const onConfirm = async () => {
    await deleteTrainingPlan(planId);
    handleDelete();
  };

  return (
    <div className="confirmation-modal">
      <div className="modal-content">
        <div
          style={{ textAlign: "center", fontSize: "1.3em", marginTop: "2vh" }}
        >
          {t("Confirm_to_delete_training_plan")}
        </div>
        <label style={{ lineHeight: "1", marginTop: "2vh" }}>
          {t("This_is_irreversible_action.")}
        </label>
        
        <div className="button-container">
          <button
            type="button"
            className="buttonCancel btn btn-primary"
            onClick={() => setShowConfirmDeleteModal(false)}
          >
            {t("Cancel")}
          </button>
          <button
            type="button"
            className="buttonAccept btn btn-primary"
            onClick={onConfirm}
          >
            {t("Delete")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteTrainingPlanModal;
